import React from 'react';

export const PanelContext = React.createContext({
  layout: 'none',
  ilevel: 0,
  iLayout: 'none',
});
